module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "mt3 responsive-margin"
  }, [_c('div', {
    staticClass: "mt3 flex flex-column inter responsive-none"
  }, [_c('div', {
    staticClass: "flex f5 top-container-realign items-center mb2 flex-row"
  }, [_c('div', {
    staticClass: "pl4 silver"
  }, [_c('router-link', {
    staticClass: "no-underline account-hover soft-grey",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v(_vm._s(_vm.$t('menu.accountsettings', {
    accountsettings: 'Account Settings'
  })))])], 1), _vm._v(" "), _c('div', {
    staticClass: "soft-grey"
  }, [_vm._v("   /   ")]), _vm._v(" "), _c('div', {
    staticClass: "soft-grey"
  }, [_vm._v(_vm._s(_vm.$t('menu.loginsecurity', {
    loginsecurity: 'Login & Security'
  })))])]), _vm._v(" "), _c('h2', {
    staticClass: "pl4 f2 mb3 title-realign cera-round-pro"
  }, [_vm._v(_vm._s(_vm.$t('menu.loginsecurity', {
    loginsecurity: 'Login & Security'
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row"
  }, [_c('div', {
    staticClass: "width responsive"
  }, [_c('LoginAndSecurity')], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "w-40 responsive-none",
    staticStyle: {
      "visibility": "hidden"
    }
  }, [_c('RightComponent', {
    attrs: {
      "image": "security-secure.png",
      "name": "Your privacy will always be our priority"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7163b140","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account-settings/screens/security/UnifiedSecurity.vue
// module id = 1159
// module chunks = 0